import { getV1CompaniesCompanyIdLoadDigestsEmails } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import {
  LoadDigestEmailDraft,
  LoadDigestLoadFilter,
  LoadDigestSelection,
  toLoadDigestSelectionQuery,
} from '~hooks/useLoadDigests/models';
import useEmailDraftsQuery from '~queries/useEmailDraftsQuery';

export default function useLoadDigestEmailDraftsQuery(
  companyId: string,
  selection: LoadDigestSelection,
  loadFilter: LoadDigestLoadFilter,
) {
  return useEmailDraftsQuery({
    enabled: Boolean(companyId),
    errorMessage: t('error_messages.load_digests.failed_to_fetch_email_drafts'),
    fetchDrafts: async (signal) => {
      const response = await getV1CompaniesCompanyIdLoadDigestsEmails({
        path: { 'company-id': companyId },
        query: toLoadDigestSelectionQuery(selection, loadFilter),
        signal,
      });
      const preview = response.data.data;

      return {
        drafts: preview.emails.map(LoadDigestEmailDraft.parse),
        skippedCustomerCount: preview.skipped_customers.length,
        skippedReceivedOrderCount: preview.skipped_received_order_count,
      };
    },
    queryKey: ['loadDigestEmailDrafts', companyId, selection, loadFilter],
  });
}
